import { useMemo } from 'react';
import { useSessionStorageState } from '@fuxi/eevee-hooks';
import { useSearchParams } from 'react-router-dom';

// 拼接推荐码与网址
export const useGenerateCodeLink = () => {
  const [data] = useSessionStorageState<{ code: string }>('RECOMMEND');
  const [searchParams] = useSearchParams();

  const state = useMemo(() => {
    const sessionCode = data?.code;
    const paramsCode = searchParams.get('code');
    const code = paramsCode || sessionCode;

    const params = new URLSearchParams({ code: code as string });

    const codeLink = window.location.origin + '?' + params.toString();

    return [code, codeLink] as const;
  }, [data, searchParams]);

  return state;
};
